import React, {Component} from 'react';
import './FancyButton.css';

class FancyButton extends Component {
	render() {
		return (
			<button
				type="button"
				className={`FancyButton ${this.props.className || ''}`}
				onClick={this.props.onClick}
				onMouseDown={this.props.onMouseDown}
				title={this.props.title}
				disabled={this.props.disabled}>
				{this.props.children}
			</button>
		);
	}
}

export default FancyButton;



// WEBPACK FOOTER //
// ./src/widgets/FancyButton.js